import * as React from "react";

interface PageTitleProps {
	pageTitle: string;
}

export function PageTitle(props: PageTitleProps){
	return (
		<title>{`${props.pageTitle} | Dream Flower Idols`}</title>
	)
}